import { Pipe, PipeTransform } from '@angular/core';
import { formatDistanceToNow, parseISO } from 'date-fns';

@Pipe({
  name: 'timeToNow',
  standalone: false,
})
export class TimeToNowPipe implements PipeTransform {
  transform(value: string | Date | number, config = { addSuffix: false }): string {
    const convertedToDate = typeof value === 'string' ? parseISO(value, { additionalDigits: 0 }) : value;
    return formatDistanceToNow(convertedToDate, config);
  }
}
